/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'feedback-collector.anonymous': 'Denne tilbakemeldingen blir sendt inn anonymt. Atlassian vil ikke kunne kontakte deg direkte om denne tilbakemeldingen',
  'feedback-collector.anonymous.title': 'Anonym tilbakemelding',
  'feedback-collector.can-be-contacted.label': 'Ja, Atlassian-team kan kontakte meg om mine erfaringer med å forbedre Atlassian-produkter og tjenester. Jeg godtar <a>Atlassians personvernerklæring</a>.',
  'feedback-collector.cancel-button.label': 'Avbryt',
  'feedback-collector.default.custom.textarea.label': 'Hva tenker du på?',
  'feedback-collector.enrol-in-research.label': 'Jeg vil gjerne delta i produktundersøkelser',
  'feedback-collector.feedback-title': 'Del tankene dine med oss',
  'feedback-collector.form.bug.label': 'Beskriv programfeilen eller saken',
  'feedback-collector.form.comment.label': 'Fortell oss hva du tenker på',
  'feedback-collector.form.empty.label': 'Velg et alternativ',
  'feedback-collector.form.question.label': 'Hva vil du vite?',
  'feedback-collector.form.suggestion.label': 'Fortell oss hva du vil forbedre',
  'feedback-collector.option.bug.label': 'Rapporter en programfeil',
  'feedback-collector.option.comment.label': 'Legg igjen en kommentar',
  'feedback-collector.option.default.label': 'Velg tilbakemelding',
  'feedback-collector.option.default.placeholder': 'Velg én',
  'feedback-collector.option.question.label': 'Stille et spørsmål',
  'feedback-collector.option.suggestion.label': 'Foreslå en forbedring',
  'feedback-collector.required.fields.summary': 'Obligatoriske felt er merket med stjerne',
  'feedback-collector.submit-button.label': 'Send en tilbakemelding',
  'feedback-collector.success-flag.description': 'Tilbakemeldingen din hjelper oss med å kontinuerlig forbedre produktene våre.',
  'feedback-collector.success-flag.title': 'Takk!',
  'feedback-collector.summary-placeholder': 'Fortell oss hva du tenker på',
  'proforma-form-builder.feedback-icon-label': 'Tilbakemelding',
  'proforma-form-builder.give-feedback': 'Gi en tilbakemelding'
};